import './styles/styles.scss'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import stripe from './stripe';
import {BootstrapVue, IconsPlugin, BIcon } from 'bootstrap-vue'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use( BootstrapVue, IconsPlugin )
Vue.component('BIcon', BIcon)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  stripe,
  render: h => h(App)
}).$mount('#app')
